var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableCopyButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.03467V2.03467C13 1.63684 12.842 1.25531 12.5607 0.974008C12.2794 0.692703 11.8978 0.534668 11.5 0.534668H5.5C5.10218 0.534668 4.72064 0.692703 4.43934 0.974008C4.15804 1.25531 4 1.63684 4 2.03467V8.03467C4 8.43249 4.15804 8.81402 4.43934 9.09533C4.72064 9.37663 5.10218 9.53467 5.5 9.53467H11.5C11.8978 9.53467 12.2794 9.37663 12.5607 9.09533C12.842 8.81402 13 8.43249 13 8.03467Z",
    stroke: "#F0F0F0",
    strokeOpacity: 0.65,
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 3.53692H2.5C2.10218 3.53692 1.72064 3.69495 1.43934 3.97626C1.15804 4.25756 1 4.63909 1 5.03692V11.0347C1 11.4325 1.15804 11.814 1.43934 12.0953C1.72064 12.3766 2.10218 12.5347 2.5 12.5347H2.50225L8.50225 12.5242C8.89968 12.5236 9.28064 12.3653 9.56146 12.084C9.84227 11.8028 10 11.4216 10 11.0242V9.53692M8.5 2.78467V7.28467M10.75 5.03467H6.25",
    stroke: "#F0F0F0",
    strokeOpacity: 0.65,
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableCopyButton);
export default __webpack_public_path__ + "static/media/TableCopyButton.2338f412ec0ededfcaebc005b762552e.svg";
export { ForwardRef as ReactComponent };